import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "storefront2--sprite",
  "use": "storefront2--sprite-usage",
  "viewBox": "0 0 18 16",
  "content": "<symbol viewBox=\"0 0 18 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"storefront2--sprite\">\n<path d=\"M17 0H1V2H17V0ZM18 10V8L17 3H1L0 8V10H1V16H11V10H15V16H17V10H18ZM9 14H3V10H9V14Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol